import styled from "styled-components";
import { responsive } from "theme/reponsive";

interface InterestPillProps {
   activeColor?: string;
}

interface SelectedInterestsProps {
   padding?: string;
}

export const SchoolApplicationFormContainer = styled.div`
   width: 595px;
   height: 70vh;
   overflow-y: scroll;
   .title {
      text-align: center;
      font-size: 22px;
      color: #444444;
      font-weight: 500;
      margin-bottom: 1.1rem;
      text-transform: capitalize;
      z-index: 200;

      ${responsive("$xsmall")`
      padding: 0 3rem;
   `};
   }

   .brief {
      text-align: center;
      font-size: 15px;
      color: #666666;
      font-weight: 400;
      max-width: 480px;
      margin: 0 auto 5rem auto;
   }

   .btn-div {
      margin-top: 30px;
   }
   ${responsive("$small")`
      width:100%;
   `};
`;

export const InterestContainer = styled.div`
   width: 100%;
   display: flex;
   flex-wrap: wrap;
   gap: 5px;
   align-items: center;
   .error-p {
      color: red;
      text-align: center;
      font-size: 14px;
   }
`;

export const InterestPill = styled.div<InterestPillProps>`
   color: ${(props) => props.activeColor ?? "#666666"};
   cursor: pointer;
   padding: 2px 15px;
   border: ${(props) =>
      props.activeColor ? `1px solid ${props.activeColor}` : `1px solid #666666`};
   border-radius: 15px;
   margin-bottom: 10px;
   font-size: 16px;
   display: flex;
   gap: 10px;
   align-items: center;
`;

export const SelectedInterestContainer = styled.div<SelectedInterestsProps>`
   width: 100%;
   padding: ${(props) => props.padding ?? "10px"};
   display: flex;
   align-items: center;
   background-color: #f1f1f1;
   margin-bottom: 20px;
`;

export const SelectedInterestPill = styled.div<InterestPillProps>`
   color: ${(props) => props.activeColor ?? "#666666"};
   cursor: pointer;
   padding: 2px 15px;
   border: ${(props) =>
      props.activeColor ? `1px solid ${props.activeColor}` : `1px solid #666666`};
   border-radius: 15px;
   font-size: 16px;
   display: flex;
   gap: 10px;
   align-items: center;
`;

export const InterestLabel = styled.label`
   margin-bottom: 0.3rem;
   font-size: 1.4rem;
   font-weight: 400;
`;

export const SelectedOthersContainer = styled.div<SelectedInterestsProps>`
   width: 20%;
   height: 49px;
   display: flex;
   padding: 8px;
   align-items: center;
   background-color: #f1f1f1;
   margin-bottom: 20px;
   ${responsive("$small")`
      width:35%;
   `};
`;

export const InputContainer = styled.div`
   width: 75%;
   ${responsive("$small")`
      width:60%;
   `};
`;
